import styled, { css } from 'styled-components';
import { down } from 'styled-breakpoints';

export const AppShellContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background[80]};
`;

export const AppShellBody = styled.div`
  display: flex;
  flex: 1;
  padding-top: ${({ theme }) => theme.layout.header};
`;

export const MainContent = styled.main`
  ${({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - ${theme.layout.header});
    margin-left: ${theme.layout.sidebar};
    background: ${theme.colors.background[80]};
    overflow-x: clip;

    ${down('lg')} {
      margin-left: 0;
    }
  `}
`;

export const PageContent = styled.div`
  ${({ theme }) => css`
    flex: 1;
    padding: ${theme.spacing[6]};
    width: 100%;

    ${down('lg')} {
      padding: ${theme.spacing[4]};
    }

    ${down('md')} {
      padding: ${theme.spacing[3]};
    }
  `}
`;
